import { findRecord, updateRecord, insertRecord, deleteRecord, updateWalletsForTransfer, transferMoney, sortArray } from "./services";

import { toJalaali } from "jalaali-js";

import { getTours as getTourMain } from "./adminTourList";

async function getModalInfo() {
  let res,
    data = {
      users: [],
      additionalCost: [],
    };
  res = await findRecord("users", {
    fields: "id, fname, lname, mobile",
  });
  data.users = res;
  res = await findRecord("tour_additional_cost", {
    tbl_name: "tours",
    conditions: "tours.main_status/in/2,4",
    fields: "tour_additional_cost.id, tour_additional_cost.title, tour_additional_cost.cost, tour_additional_cost.tour_id",
  });
  data.additionalCost = res.map((value) => {
    return {
      ...value,
      cost: parseInt(value.cost),
    };
  });

  return data;
}

async function getTours(conditions = "") {
  let res,
    data = [
      {
        id: -1,
        title: "",
        duration: "",
        transferType: "",
        passangers: [
          {
            id: -1,
            fullname: "",
            codemelli: "",
            mobile: "",
          },
        ],
      },
    ];
  if (conditions == "") conditions = "main_status/=/4";
  else conditions = "main_status/=/4@@" + conditions;
  res = await getTourMain(conditions);
  let tourIds = res.map((value) => value.id),
    tours = res.map((value) => {
      delete value.main_status;
      return value;
    });
  res = await findRecord("tour_reservation_items", {
    conditions: `tour_id/in/${tourIds.join(",")}`,
    fields: "uid, tour_id",
  });
  res = res.reduce((total, value) => {
    if (typeof total.find((val) => val.tour_id == value.tour_id && val.uid == value.uid) === "undefined") total.push(value);
    return total;
  }, []);
  let uids = res.map((value) => value.uid),
    reserves = res;
  res = await findRecord("users", {
    conditions: `id/in/${uids.join(",")}`,
    fields: "id, fname, lname, codemelli, mobile",
  });
  reserves = reserves.reduce((total, value) => {
    let user = res.find((val) => val.id == value.uid);
    if (typeof user !== "undefined") {
      total.push({
        tour_id: value.tour_id,
        user: {
          id: user.id,
          fullname: user.fname + " " + user.lname,
          codemelli: user.codemelli,
          mobile: user.mobile,
        },
      });
    }
    return total;
  }, []);
  data = tours.map((tour) => {
    let passangers = reserves.reduce((total, value) => {
      if (tour.id == value.tour_id) total.push(value.user);
      return total;
    }, []);
    return {
      ...tour,
      passangers,
    };
  });
  return data;
}

async function getReservation() {
  let res,
    data = [
      {
        id: -1,
        mtm: 0,
        tour: {
          id: -1,
          title: "",
          mainprice: 0,
          main_status: 0,
        },
        buyer: {
          id: -1,
          fullname: "",
        },
        passangers: [
          {
            id: -1,
            fullname: "",
          },
        ],
        factor: {
          id: -1,
          total_amt: 0,
          total_count: 0,
          total_discount: 0,
          total_paid: 0,
        },
        additionalCost: [
          {
            id: 0,
            title: "",
            cost: 0,
            discount: 0,
          },
        ],
      },
    ];
  res = await findRecord("tours", {
    fields: "id, mainprice, title, main_status",
    conditions: "main_status/in/2,4",
  });
  let tourIds = res.map((value) => value.id),
    tours = res.map((value) => {
      return {
        ...value,
        mainprice: parseInt(value.mainprice),
      };
    });

  res = await findRecord("tour_reservation_items", {
    conditions: `tour_id/in/${tourIds.join(",")}`,
    fields: "id, uid, muid, mtm, tour_id, other_params, factor_id",
  });
  res = res.map((value) => {
    if (value.other_params == "") return { ...value, other_params: { additional_costs: [] } };
    value.other_params = JSON.parse(value.other_params);
    return value;
  });
  let userIds = res.reduce((total, value) => (total.includes(value.uid) ? total : [...total, value.uid]), []),
    additionalCostIds = res.reduce((total, value) => {
      if (typeof value.other_params.additional_costs !== "undefined") {
        let x = value.other_params.additional_costs.reduce((tot, val) => {
          if (!total.includes(val.id)) tot.push(val.id);
          return tot;
        }, []);
        total.concat(x);
      }
      return total;
    }, []),
    factorIds = res.reduce((total, value) => {
      if (!total.includes(value.factor_id)) total.push(value.factor_id);
      return total;
    }, []),
    reserves = res;

  res = await findRecord("factors", {
    conditions: `id/in/${factorIds.join(",")}`,
    fields: "id, total_count, total_amt, total_discount, total_paid",
  });
  let factors = res.map((value) => {
    return {
      ...value,
      total_count: parseInt(value.total_count),
      total_amt: parseInt(value.total_amt),
      total_discount: parseInt(value.total_discount),
      total_paid: parseInt(value.total_paid),
    };
  });
  res = await findRecord("users", {
    conditions: `id/in/${userIds.join(",")}`,
    fields: "id, fname, lname",
  });
  let users = res.map((value) => {
    return {
      id: value.id,
      fullname: `${value.fname} ${value.lname}`,
    };
  });
  res = await findRecord("tour_additional_cost", {
    conditions: `id/in/${additionalCostIds.join(",")}`,
    fields: "id, title, cost, tour_id",
  });
  let additionalCosts = res;

  data = reserves.reduce((total, value) => {
    let index = total.findIndex((val) => val.factor.id == value.factor_id);
    if (index != -1) {
      if (value.uid == value.muid) return total;
      let user = users.find((val) => val.id == value.uid);
      if (typeof user !== "undefined") {
        total[index].passangers.push(user);
      }
      return total;
    } else {
      let d = {
        id: value.id,
        mtm: "",
      };
      try {
        let x = toJalaali(new Date(parseInt(value.mtm) * 1000));
        d.mtm = `${x.jy}/${x.jm < 10 ? "0" : ""}${x.jm}/${
          x.jd < 10 ? "0" : ""
        }${x.jd}`;
      } catch (err) {
        console.log(err);
        console.log(value);
        return total;
      }
      let tour = tours.find((val) => val.id == value.tour_id),
        factor = factors.find((val) => val.id == value.factor_id);
      if (typeof tour === "undefined" || typeof factor === "undefined") {
        return total;
      }
      d.tour = tour;
      d.factor = factor;
      if (value.muid == value.uid) {
        let user = users.find((val) => val.id == value.muid);
        if (typeof tour === "undefined") {
          return total;
        }
        d.buyer = user;
        d.passangers = [];
      } else {
        let user = users.find((val) => val.id == value.muid);
        if (typeof tour === "undefined") {
          return total;
        }
        d.buyer = user;
        user = users.find((val) => val.id == value.uid);
        if (typeof tour === "undefined") {
          return total;
        }
        d.passangers.push(user);
      }
      d.additionalCost = value.other_params.additional_costs.reduce((tot, val) => {
        let ac = additionalCosts.find((v) => v.id == val.id);
        if (typeof ac === "undefined") return tot;
        tot.push({
          id: ac.id,
          title: ac.title,
          cost: parseInt(ac.cost),
          discount: parseInt(val.discount),
        });
      }, []);
      return [...total, d];
    }
  }, []);
  console.log(reserves);
  console.log(data);
  return data;
}

async function saveReservation(data, factor_id = -1) {
  let res;
  if (data.buyer.id == -1) {
    res = await insertRecord("users", {
      fname: data.buyer.fname,
      lname: data.buyer.lname,
      codemelli: data.buyer.codemelli,
      mobile: data.buyer.mobile,
    });
    if (!res.status) return false;
    data.buyer.id = res.result.id;
  }
  let flag = false;
  await Promise.all(
    data.passangers.map(async (value) => {
      if (value.id == -1) {
        res = await insertRecord("users", {
          fname: data.buyer.fname,
          lname: data.buyer.lname,
          codemelli: data.buyer.codemelli,
          mobile: data.buyer.mobile,
        });
        if (!res.status) flag = true;
        value.id = res.result.id;
      }
      return value;
    })
  );
  if (flag) return false;

  if (factor_id == -1) {
    let paidState = data.total_amt - data.total_discount > 0 ? 0 : 2;
    res = await insertRecord("factors", {
      total_count: data.total_count,
      total_discount: data.total_discount,
      total_amt: data.total_amt,
      main_state: paidState,
    });
    if (!res.status) return false;
    factor_id = res.result.id;

    let reserves = Array(data.passangers.length + 1)
      .fill({
        uid: data.buyer.id,
        muid: data.buyer.id,
        tour_id: data.tour_id,
        other_params: JSON.stringify({
          additional_costs: data.additionalCosts,
        }),
        factor_id,
        main_state: paidState,
      })
      .map((value, index) => {
        if (index == 0) return value;
        value.uid = data.passangers[index - 1].id;
        return value;
      });

    flag = false;
    await Promise.all(
      reserves.map(async (value) => {
        res = await insertRecord("tour_reservation_items", value);
        flag = res.status ? flag : true;
        return value;
      })
    );
    return !flag;
  } else {
    let paidState =
      data.total_amt - data.total_discount - data.total_paid > 0 ? 0 : 2;

    res = await updateRecord("factors", {
      keyvalues: {
        total_count: data.total_count,
        total_discount: data.total_discount,
        total_amt: data.total_amt,
        main_state: paidState,
      },
      conditions: `id/=/${factor_id}`,
    });
    if (!res.status) return false;

    res = await findRecord("tour_reservation_items", {
      fields: "id, muid, uid, other_params, total_pay_state",
      conditions: `factor_id/=/${factor_id}@@tour_id/=/${data.tour_id}`,
    });
    let deleteReserves = [],
      updateReserves = [],
      insertReserves = [];
    let passangers = data.passangers.filter(() => true);
    res.forEach((value) => {
      let index = data.passangers.findIndex((val) => val.id == value.uid);
      let total_pay_state = paidState == 2 ? 2 : value.total_pay_state;
      if (index != -1) {
        updateReserves.push({
          id: value.id,
          value: {
            muid: data.buyer.id,
            other_params: JSON.stringify({
              additional_costs: data.additionalCosts,
            }),
            total_pay_state,
            main_state: paidState,
          },
        });
        passangers.splice(index, 1);
        return;
      }
      deleteReserves.push(value.id);
    });
    insertReserves = passangers.map((value) => {
      return {
        uid: value.id,
        muid: data.buyer.id,
        tour_id: data.tour_id,
        other_params: JSON.stringify({
          additional_costs: data.additionalCosts,
        }),
        main_state: paidState,
        total_pay_state: paidState,
        factor_id,
      };
    });
    flag = false;
    await Promise.all(
      insertReserves.map(async (value) => {
        res = await insertRecord("tour_reservation_items", value);
        flag = res.status ? flag : true;
        return value;
      })
    );
    if (flag) return false;

    flag = false;
    await Promise.all(
      updateReserves.map(async (value) => {
        res = await updateRecord("tour_reservation_items", {
          keyvalues: value.value,
          conditions: `id/=/${value.id}`,
        });
        flag = res.status == 1 ? flag : true;
        return value;
      })
    );
    if (flag) return false;

    flag = false;
    res = await deleteRecord("tour_reservation_items", `id/=/${deleteReserves.join(",")}`);
    if (res.status != 1) return false;

    return true;
  }
}

export { getModalInfo, getTours, getReservation, saveReservation };
